import * as React from "react";
import { forwardRef } from "react";
const SvgEllipse = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 26, height: 25, viewBox: "0 0 26 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M18.75 12.2222C18.75 16.3793 16.0376 19.4722 13 19.4722C9.96238 19.4722 7.25 16.3793 7.25 12.2222C7.25 8.06508 9.96238 4.97217 13 4.97217C16.0376 4.97217 18.75 8.06508 18.75 12.2222Z", stroke: "#2B2B35", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgEllipse);
export { ForwardRef as ReactComponent };
